import React, { useEffect, useState } from "react";
// import logo from "../../../RichImages/newradhaLogo.png";
import { GET_CONTACT } from "../../service/admin.service";
import logo from "../../../RichImages/newradhaLogo.png";
import begameble from "../../../RichImages/begamble.png";
import gambling from "../../../RichImages/gamblingtherapy.png";

function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    consent: false, // new field
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Name is required";
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      errs.email = "Valid email required";
    if (!form.phone.match(/^[0-9]{10}$/))
      errs.phone = "Valid 10-digit phone required";
    if (!form.message.trim()) errs.message = "Message is required";
    if (!form.consent) errs.consent = "You must accept the terms";
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleCheckboxChange = (e) => {
    setForm({ ...form, consent: e.target.checked });
    setErrors({ ...errors, consent: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
    } else {
      alert("Thank you for contacting us!");
      setForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      });
    }
  };
  const [getData, setgetData] = useState([]);
  const getResponseData = async () => {
    const res = await GET_CONTACT();
    setgetData(res.data[0]);
  };
  useEffect(() => {
    getResponseData();
  }, []);
  return (
    <div>
      {/* <form className="contact-form" onSubmit={handleSubmit}>
        <h2>Contact Us</h2>

        <label>
          Name <span className="error">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
        />
        {errors.name && <span className="error">{errors.name}</span>}

        <label>
          Email <span className="error">*</span>
        </label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
        {errors.email && <span className="error">{errors.email}</span>}

        <label>
          Phone Number <span className="error">*</span>
        </label>
        <input
          type="text"
          name="phone"
          value={form.phone}
          onChange={handleChange}
        />
        {errors.phone && <span className="error">{errors.phone}</span>}

        <label>
          Company Name <span className="error">*</span>
        </label>
        <input
          type="text"
          name="company"
          value={form.company}
          onChange={handleChange}
        />
        {errors.company && <span className="error">{errors.company}</span>}

        <label>
          Message <span className="error">*</span>
        </label>
        <textarea
          name="message"
          rows="4"
          value={form.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && <span className="error">{errors.message}</span>}

        <label className="checkbox-container">
          <input
            type="checkbox"
            name="termsAccepted"
            checked={form.termsAccepted}
            onChange={handleChange}
          />
          I agree to the terms and conditions
        </label>
        {errors.termsAccepted && (
          <span className="error">{errors.termsAccepted}</span>
        )}

        <button type="submit">Submit</button>
      </form> */}

      <div className="cu-container">
        {/* <div className="cu-left">
          <div className="cu-logo-section">
            <h1>Radha567</h1>
          </div>
          <div className="cu-info-section">
            <h2>Contact Info</h2>
            <p><strong>📍 Address:</strong> 123 Green Street, Earth City</p>
            <p>
              <strong>✉️ Email:</strong> contact@example.com
            </p>
            <p>
              <strong>📞 Phone:</strong> +91 {getData && getData.number}
            </p>
            <p>
              <strong>🕒 Support Hours:</strong> Mon–Fri, 9AM to 5PM
            </p>
            <div className="d-flex justify-content-center">
              <img
                src={logo}
                className="img-fluid footer-image float-left"
                alt="https://radha567.com/"
              />
            </div>
            <div className="footer-right-image">
            <p className="contactpara">
              Players need to be 18+ in order to register. Underage gambling is
              prohibited.
            </p>
            </div>
            <div className="col-xl-12 col-md-12 ">
              <div className="fi-container">
                <img
                  className="fi-image fi-image-1"
                  src={begameble}
                  alt="BeGambleAware"
                />
                <img
                  className="fi-image fi-image-2"
                  src={gambling}
                  alt="Gambling Commission"
                />
              </div>
            </div>
          </div>
        </div> */}

        <div className="cu-right">
          <h2>Get in Touch</h2>
          <form onSubmit={handleSubmit}>
            <div className="cu-form-group">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
              />
              {errors.name && <span className="cu-error">{errors.name}</span>}
            </div>

            <div className="cu-form-group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
              />
              {errors.email && <span className="cu-error">{errors.email}</span>}
            </div>

            <div className="cu-form-group">
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
              />
              {errors.phone && <span className="cu-error">{errors.phone}</span>}
            </div>

            <div className="cu-form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange}
              />
              {errors.message && (
                <span className="cu-error">{errors.message}</span>
              )}
            </div>
            <div className="" style={{ marginBottom: "10px" }}>
              <label htmlFor="tc-consent" className="tc-checkbox-label">
                <input
                  type="checkbox"
                  id="tc-consent"
                  className="tc-checkbox-input"
                  checked={form.consent}
                  onChange={handleCheckboxChange}
                />
                &nbsp;
                <span className="tc-custom-checkbox"></span>I agree to receive
                Promotional & Informational Communication from Radha567 through
                Emails, Call, SMS and RCS Messages
              </label>
              {errors.consent && (
                <span className="cu-error">{errors.consent}</span>
              )}
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
      
    </div>
  );
}

export default ContactUs;
